import StyledHeading from '/shared/styled/components/StyledHeading';
import StyledParagraph from '/shared/styled/components/StyledParagraph';
import ElectricityHeatSteamEmissionsDisplay from '/business/shared/components/questions/scope2/_education/ElectricityHeatSteamEmissionsDisplay';

export const BottomLocationsPage = (
  <>
    <div className="hse-landingbtm">
      <StyledHeading as="h2" $type="h1" $hasExtraBottomMargin $hasSuperTopMargin>
        Inputting location data
      </StyledHeading>
      <StyledParagraph $largeText>For each location, specify:</StyledParagraph>
      <ul>
        <li>
          <StyledParagraph $largeText>
            Whether your business <b>occupies the entire location</b> or <b>shares</b> it with others.
          </StyledParagraph>
        </li>
        <li>
          <StyledParagraph $largeText>
            Whether energy consumption is tracked using a <b>dedicated</b> or <b>shared meter</b>.
          </StyledParagraph>
        </li>
        <li>
          <StyledParagraph $largeText>
            When combined with your <b>consumption data</b> and any <b>energy attribute certificates</b>, this
            information provides a clearer, more accurate understanding of your{' '}
            <b>energy use and associated emissions on a location-by-location basis.</b>
          </StyledParagraph>
        </li>
      </ul>
      <ElectricityHeatSteamEmissionsDisplay />
    </div>
  </>
);
